import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class SbcCdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.SBC220, DeviceModel.SBC240, DeviceModel.SBC441];

	public override getDeviceNameMaxLength(_model: DeviceModel): number | undefined {
		return 8;
	}
}
